<template>
  <v-app id="onIpfc">
    
    <defNavBar title="Ares - Partner invoice" :actions="ipfc.action_items" :home="true" @actionClick="actionClick"/>

    <v-main> 
      
      <v-container fluid>
        <v-row cols="12">  
          
          <v-col cols="6" class="px-1"> <!-- Links -->
            <v-container>
              <v-row>
                <v-col cols="12" class="px-1">
                  <v-card>
                  <v-form ref="ipfcCard1">
                  <v-card-title>
                    Invoice {{ ipfc.ipfc_nr }} 
                  </v-card-title>

                  <v-row no-gutters>
                    <v-col cols="4" class="px-1">
                      <v-text-field v-model="ipfc.ipfc_dt" readonly label="Invoice date"></v-text-field>
                    </v-col>
                    <v-col cols="8" class="px-1">
                      <v-text-field v-model="ipfc.ipfc_oms" readonly label="Description"></v-text-field>
                    </v-col>
                  </v-row>
                  
                  <v-row no-gutters>
                    <v-col cols="4" class="px-1">
                      <v-text-field v-model="ipfc.inpt_naam" readonly label="Host"></v-text-field>
                    </v-col>
                    <v-col cols="2" class="px-1">
                      <v-text-field v-model="ipfc.land_code" readonly label="Country"></v-text-field>
                    </v-col>
                    <v-col cols="2" class="px-1">
                      <v-text-field v-model="ipfc.inpt_btw" readonly label="VAT"></v-text-field>
                    </v-col>
                    <v-col cols="2" class="px-1">
                      <v-text-field v-model="ipfc.land_code_btw" readonly label="Country VAT"></v-text-field>
                    </v-col>
                  </v-row>

                  
                  
                  
                  <v-row no-gutters>
                    <v-col cols="12" class="px-1">
                  <v-simple-table dense>
                      <template v-slot:default>
                        <thead>
                          <tr>
                            
                            <td>Description</td>
                            <td align="right">Excl VAT</td>
                            <td>VAT id</td>
                            <td align="right">VAT</td>
                            <td align="right">Total</td>
                          </tr>  
                        </thead>  
                        <tbody v-for="(ipfrRecord,i) in ipfc.ipfr" :key="i">
                          <tr>
                         
                           <td>{{ipfrRecord.ipfr_oms}}</td>
                           <td align="right">{{ipfrRecord.ipfr_bedrag_excl}}</td>
                           <td>{{ipfrRecord.ipfr_btwcode}}</td>
                           <td align="right">{{ipfrRecord.ipfr_bedrag_btw}}</td>
                           <td align="right">{{ipfrRecord.ipfr_bedrag_incl}}</td>
            
                          </tr>
                          <tr v-for="(ifrdRecord,j) in ipfrRecord.ifrd" :key="j"> 
                              
                              <td>{{ifrdRecord.ifrd_oms}}</td> 
                              <td align="right" v-if="ifrdRecord.ifrd_deci_val == 'Yes'">{{ifrdRecord.ifrd_deci}}</td> 
                          </tr>  
                        </tbody>
                      </template>
                    </v-simple-table>
                    </v-col>
                  </v-row>
                    
                  </v-form>
                  </v-card>
                </v-col>
              </v-row>
            </v-container>
          </v-col>
        </v-row>
      </v-container>
      <rmIpfc ref="rmIpfc"></rmIpfc>
      <sentIpfcByEmail ref="sentIpfcByEmail"></sentIpfcByEmail>
      <showIpfcEmails ref="showIpfcEmails"></showIpfcEmails>
    </v-main>
  </v-app>
</template>




<script>
import sentIpfcByEmail from "@/views/task/inpt/ipfc/sentIpfcByEmail";
import showIpfcEmails from "@/views/task/inpt/ipfc/showIpfcEmails";  
import defNavBar from '@/components/ui/navbars/navbar.vue';

export default {
  components: {
    sentIpfcByEmail,
    showIpfcEmails,
    defNavBar
  },
  props: ['ipfc_encrid'],
  data() {
    return {
      ipfc: {
        action_items: []  /* moet pre defined ivm length check */
      },
      snackbar: false,
      snackbarMessage: '',
      hfrt_codeKeuzes: [],
    }
    
  },
  mounted() {
    this.$axios
      .post("ares/json/ares/task/inpt/ipfc/getIpfc.p", {
        header: {
          token: this.$session.get("ARES"),
          clientSessionId: this.$session.id(),
          request: "getIpfc"
        },
        getIpfc: {
          ipfc_encrid: this.ipfc_encrid
       }
      })
      .then(res => {
        if (res.data.error) {
          console.log(res.data.error);
        } else {
           this.ipfc = res.data.getIpfc;
           document.title = 'Partner invoice ' + res.data.getIpfc.ipfc_nr;
        }
      });

  },
  methods: {
    actionClick(action) {
      if (action == "sentIpfcByEmail") {
        this.$refs.sentIpfcByEmail.open(this.ipfc_encrid);
      }
      if (action == "showIpfcEmails") {
        this.$refs.showIpfcEmails.open(this.ipfc_encrid);
      }
    }
  }
};

</script> 

